import { useI18nSubscription } from '../../i18n/useI18nSubscription.js';
import { i18n } from '../../../i18n/index.js';
// Переключатель размышления модели. Стоит в шапке чата, чтобы можно было прогнать
// один и тот же вопрос в двух режимах подряд и сравнить скорость с качеством.
//
// Выключение работает только на reasoning-моделях OpenAI-совместимого пути
// (сейчас это qwen у NeuralDeep); на остальных шлюз запрос не меняет.
import type { ReactElement } from 'react';
import { Switch, Tooltip } from 'antd';

import { useReasoningMode } from '../lib/reasoningMode.js';

export function ReasoningModeSwitch(): ReactElement {
  useI18nSubscription();
  const { enabled, setEnabled } = useReasoningMode();

  return (
    <Tooltip
      title={
        enabled
          ? i18n.t(
              'crm.features.features.ai.chat.components.reasoningmodeswitch.model_obdumyvaet_otvet_pered_tem_kak_ego_',
            )
          : i18n.t(
              'crm.features.features.ai.chat.components.reasoningmodeswitch.model_otvechaet_srazu_bez_razmyshleniya_byst',
            )
      }
    >
      {/*
        Не `label`: `button` — labelable-элемент, и обёртка вокруг Switch добавляет
        второй путь активации. Клик по подписи и клик по самому тумблеру начинают
        вести себя по-разному, а выглядит это как «тумблер не переключается».
        Подпись переключает явным обработчиком.
      */}
      <span className="flex items-center gap-2 text-xs text-stone-500">
        <Switch
          size="small"
          checked={enabled}
          onChange={setEnabled}
          aria-label={i18n.t(
            'crm.features.features.ai.chat.components.reasoningmodeswitch.razmyshlenie_modeli',
          )}
        />
        <button
          type="button"
          className="cursor-pointer text-xs text-stone-500"
          onClick={() => setEnabled(!enabled)}
        >
          {i18n.t('crm.features.features.ai.chat.components.reasoningmodeswitch.razmyshlenie')}{' '}
          {enabled
            ? i18n.t('crm.features.features.ai.chat.components.reasoningmodeswitch.vkl')
            : i18n.t('crm.features.features.ai.chat.components.reasoningmodeswitch.vykl')}
        </button>
      </span>
    </Tooltip>
  );
}
